import { render, staticRenderFns } from "./Nutech.vue?vue&type=template&id=7bfcf607&scoped=true&"
import script from "./Nutech.vue?vue&type=script&lang=js&"
export * from "./Nutech.vue?vue&type=script&lang=js&"
import style0 from "./Nutech.vue?vue&type=style&index=0&id=7bfcf607&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bfcf607",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
